<div #modal class="sir-modal">
    <div #container class="sir-container" tabindex="-1">
        <sirius-icon [name]="'x'" (click)="close()"></sirius-icon>
        <div class="sir-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
<sirius-dimmer [focusElement]="modal"></sirius-dimmer>
